import Splide from '@splidejs/splide';
import Utils from '../Utils';

const ThingsToDo = {
    init() {
        this.sliders = [];
        document.querySelectorAll('[data-featured-things]').forEach((root) => {
            const dom = this.cacheDom(root);
            if (dom) {
                this.sliders.push(this.createSlider(dom));
                this.observeRevealSpace(dom);
            }
        });
    },

    cacheDom(root) {
        const slider = root.querySelector('[data-featured-things-slider]');
        if (!slider) return null;

        return {
            root,
            slider,
            prev: root.querySelector('[data-featured-things-prev]'),
            next: root.querySelector('[data-featured-things-next]'),
        };
    },

    createSlider(dom) {
        const originalCount = dom.slider.querySelectorAll('.featured-things__item').length;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const canLoop = originalCount >= 2;

        const splide = new Splide(dom.slider, {
            type: canLoop ? 'loop' : 'slide',
            perPage: 3,
            focus: 'center',
            gap: '60px',
            pagination: false,
            arrows: false,
            speed: reduceMotion ? 0 : 500,
            drag: !reduceMotion,
            snap: true,
            trimSpace: false,
            updateOnMove: true,
            i18n: {
                prev: 'Previous',
                next: 'Next',
            },
            breakpoints: {
                480: {
                  perPage: 1,
                },
              },
        });

        splide.on('mounted', () => this.measureRevealSpace(dom));
        splide.on('resized', () => this.measureRevealSpace(dom));

        if (dom.prev) {
            dom.prev.addEventListener('click', () => splide.go('<'));
        }
        if (dom.next) {
            dom.next.addEventListener('click', () => splide.go('>'));
        }

        splide.mount();
        return splide;
    },

    measureRevealSpace(dom) {
        const items = Array.from(dom.root.querySelectorAll('.featured-things__item'));
        let maxReveal = 0;

        // Measure every slide as collapsed. The active slide otherwise has
        // a shorter content padding, so --collapsed-height would disagree.
        items.forEach((item) => item.classList.add('is-measuring'));

        items.forEach((item) => {
            const card = item.querySelector('.featured-things__card');
            const img = item.querySelector('.featured-things__img');
            const content = item.querySelector('.featured-things__content');
            const reveal = item.querySelector('.featured-things__reveal');
            if (!card || !img || !content) return;

            const styles = getComputedStyle(card);
            const collapsed =
                img.offsetHeight +
                content.offsetHeight +
                parseFloat(styles.paddingTop) +
                parseFloat(styles.paddingBottom);

            item.style.setProperty('--collapsed-height', `${collapsed}px`);
            card.style.setProperty('--collapsed-height', `${collapsed}px`);

            if (reveal) {
                const revealHeight = reveal.offsetHeight;
                item.style.setProperty('--reveal-height', `${revealHeight}px`);
                card.style.setProperty('--reveal-height', `${revealHeight}px`);
                maxReveal = Math.max(maxReveal, revealHeight);
            } else {
                item.style.setProperty('--reveal-height', '0px');
                card.style.setProperty('--reveal-height', '0px');
            }
        });

        items.forEach((item) => item.classList.remove('is-measuring'));

        dom.root.style.setProperty('--reveal-space', `${maxReveal}px`);
    },

    observeRevealSpace(dom) {
        const update = Utils.debounce(() => this.measureRevealSpace(dom), 100);
        const observer = new ResizeObserver(update);

        observer.observe(dom.slider);

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.measureRevealSpace(dom));
        }
    },
};

export default ThingsToDo;
